/** モック（有報開示指標.html）の colgroup 幅比率 */

/** @type {readonly string[]} */
export const SEGMENT_TABLE_COLUMN_WIDTHS = ['50%', '25%', '25%']

/** @type {readonly string[]} */
export const COMPANY_STATUS_TABLE_COLUMN_WIDTHS = [
  '20%',
  '9%',
  '11.83%',
  '11.83%',
  '11.83%',
  '11.83%',
  '11.83%',
  '11.85%'
]

/** @type {readonly string[]} */
export const DIVERSITY_TABLE_COLUMN_WIDTHS = [
  '22%',
  '11.14%',
  '11.14%',
  '11.14%',
  '11.14%',
  '11.14%',
  '11.14%',
  '11.16%'
]
